import React, { useState } from 'react';
import { Redirect } from 'react-router';
import { Grid } from '@material-ui/core';
import { CreateTeamModal } from 'components/Modals/CreateTeamModal';
import { JoinCreateTeamModal } from 'components/Modals/JoinCreateTeamModal';
import { JoinTeamModal } from 'components/Modals/JoinTeamModal';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'redux/store';
import './Home.scss';
import { selectTeam } from 'redux/thunks';
import { withRouteInformation } from 'components/withRouteInformation';
import { EulaModal } from 'components/Modals/EulaModal';
import { SendShoutOutModal } from 'components/Modals/SendShoutOutModal';

interface HomeProps {
	pathname: string;
}

const Home: React.FC<HomeProps> = (props: HomeProps) => {
	const teams = useSelector((state: RootStore) => state.user.teams);
	const selectedTeam = useSelector((state: RootStore) => state.user.selectedTeam);
	const hasAcceptedTerms = useSelector((state: RootStore) => state.user.hasAcceptedTerms);
	const [pageSelected, setPageSelected] = useState('home');
	const dispatch = useDispatch();
	let view = <></>;

	if (!hasAcceptedTerms) {
		view = <EulaModal open={true} openFromMenu={false} />;
	} else if (teams.length && !selectedTeam) {
		dispatch(selectTeam(''));
	} else if (teams.length && selectedTeam) {
		view = <Redirect push to={`/team/${selectedTeam?.teamId}/all`} />;
	} else if (pageSelected === 'create') {
		view = <CreateTeamModal open={true} hideBackdrop={true} onBackClicked={() => setPageSelected('home')} onCloseClicked={() => setPageSelected('home')} />;
	} else if (pageSelected === 'join') {
		view = <JoinTeamModal open={true} hideBackdrop={true} onBackClicked={() => setPageSelected('home')} />;
	} else if (pageSelected === 'shoutout') {
		view = (
			<SendShoutOutModal open={true} hideBackdrop={true} onBackClicked={() => setPageSelected('home')} onCloseClicked={() => setPageSelected('home')} />
		);
	} else {
		view = (
			<JoinCreateTeamModal
				open={true}
				hideBackdrop={true}
				onCreateTeamClicked={() => setPageSelected('create')}
				onJoinTeamClicked={() => setPageSelected('join')}
				onSendShoutOutClicked={() => setPageSelected('shoutout')}
			/>
		);
	}

	return teams.length > 0 && hasAcceptedTerms ? (
		view
	) : (
		<Grid container spacing={0} direction='column' alignItems='center' justify='center' className='page-grid'>
			{view}
		</Grid>
	);
};

export default withRouteInformation(Home);
